import './App.css';
import Counseling from './components/Counseling';
import FAQ from './components/FAQ';
import FloatingSidebar from './components/FloatingSidebar';
import FooterNew from './components/FooterNew';
import Navbar from './components/NavBar';
import StudyMethod from './components/StudyMethod';
import NewStudyMethod from './components/NewStudyMethod';
import Trailer from './components/Trailer';
import Financing from './components/Financing';
import Header from './components/Header';
import HeaderTaller from './components/HeaderTaller';
import Master from './components/Master';
import Memberships from './components/Memberships';
import HeaderForm from './components/HeaderForm';
import Gallery from './components/Gallery';

import Plans from './components/Plans';

function App() {
	return (
		<div className='App'>
			<Navbar />
			{/* <FloatingSidebar /> */}
			<Header />
			<HeaderForm />
			{/* <HeaderTaller /> */}
			<Master />
			{/* <Trailer /> */}
			<NewStudyMethod />
			<Gallery />
			<Plans />
			{/* <Memberships /> */}
			{/* <Financing /> */}
			<Counseling />
			<FAQ />
			<FooterNew />
		</div>
	);
}

export default App;
